import { Base } from '../base-component';

import './needs-goals-item.component.scss';


export class NeedsGoalsItem extends Base {

	constructor(element){
		super(element)
	}

	init(){};

	bindEvents(){};

}



// WEBPACK FOOTER //
// ./components/needs-goals-item/needs-goals-item.component.ts